import { Dropdown } from "react-bootstrap";

import { Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem } from "../../components";
import { MdDelete } from "react-icons/md";
// import { handleDeleteCategory, handleToggleEnable } from "../../pages/categories-manage/CategoriesList";
// import { MdDisabledByDefault } from "react-icons/md";
// import { handleDeleteCountry } from "../../pages/countries-manage/CountriesList"
// import { handleDeleteState } from "../../pages/states-manage/StatesList"
import { handleDeleteCity } from "../../pages/cities-manage/CitiesList"
import { createPortal } from "react-dom"
export const userColumns = ({ setCitiesData }) => {
    return [
        {
            name: "City ID",
            selector: (row) => row.city_id,
            cell: (row) => (
                <span>{row.city_id}</span>
            ),
            sortable: true,
        },

        {
            name: "City Name",
            selector: (row) => row.name,
            cell: (row) => (
             
                        <span className="small text" style={{ whiteSpace: "nowrap" }}>
                            {row.name}
                        </span>
                 


            ),
            sortable: true,
            minWidth: "150px",
        },
       
        {
            name: "State",
            selector: (row) => row.WebtagZone.name,
            cell: (row) => (
             
                        <span className="small text" style={{ whiteSpace: "nowrap" }}>
                            {row.WebtagZone.name}
                        </span>
                 


            ),
            sortable: true,
            minWidth: "150px",
        },
        {
            name: "COUNTRY",
            selector: (row) => row.WebtagZone.WebtagCountry.name,
            cell: (row) => (
             
                        <span className="small text" style={{ whiteSpace: "nowrap" }}>
                            {row.WebtagZone.WebtagCountry.name}
                        </span>
                 


            ),
            sortable: true,
            minWidth: "150px",
        },
        // {
        //     name: "CODE",
        //     selector: (row) => row.code,
        //     cell: (row) => (
             
        //                 <span className="small text" style={{ whiteSpace: "nowrap" }}>
        //                     {row.code}
        //                 </span>
                 


        //     ),
        //     sortable: true,
        //     minWidth: "150px",
        // },
        {
            name: "action",
            cell: (row) => (
                <div className="text-end w-100">
                    <Dropdown>
                        <Dropdown.Toggle size="sm" as={CustomDropdownToggle} className="btn btn-sm btn-icon btn-zoom me-n1">
                            <Icon name="more-v"></Icon>
                        </Dropdown.Toggle>
                        {createPortal(

                        <Dropdown.Menu className="dropdown-menu-sm" as={CustomDropdownMenu} align="end">
                            <div className="dropdown-content py-1">
                                <LinkList className="link-list-hover-bg-primary link-list-md">
                                    <LinkListItem to={`/cities-manage/cities-list/${row.city_id}`}>
                                        <Icon name="edit"></Icon><span>Edit</span>
                                    </LinkListItem>
                                 
                                    <LinkListItem  className="delete-ittem" to="#" onClick={() => handleDeleteCity(row.city_id, setCitiesData)}>
                                    <MdDelete/><span>Delete</span>
                                    </LinkListItem>
                                </LinkList>
                            </div>
                        </Dropdown.Menu>
                        ,
                         document.body
                     )}
                                         </Dropdown>
                </div>
            ),
            sortable: false,

        },
    ]
};


